var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMuted = function SvgMuted(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 96 96"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#33B1E3",
    d: "M5.945 47.563a41.537 41.537 0 1 0 83.075 0 41.537 41.537 0 0 0-83.075 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M56.115 40.132a2.32 2.32 0 0 0-3.269 0 2.32 2.32 0 0 0 0 3.269 6.927 6.927 0 0 1 0 9.806 2.32 2.32 0 0 0 0 3.269 2.32 2.32 0 0 0 3.269 0c4.51-4.517 4.51-11.834 0-16.344"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M62.656 33.594a2.31 2.31 0 0 0-3.269 3.269c6.315 6.315 6.315 16.559 0 22.881a2.32 2.32 0 0 0 0 3.269 2.32 2.32 0 0 0 3.27 0c8.119-8.127 8.119-21.299 0-29.419M47.761 55.041V32.903c0-1.686-1.107-2.258-2.466-1.24l-9.858 7.399h-.38zM29.397 39.055h-.134a3.053 3.053 0 0 0-3.076 3.053v12.384c0 1.664 1.382 3.053 3.076 3.053h6.166l9.858 7.4c1.375 1.025 2.467.467 2.467-1.241v-1.546z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M30.868 28.944 58.139 63.25l-3.469 2.756L27.398 31.7z"
  })));
};
export default SvgMuted;